import PropTypes from 'prop-types';
import React from 'react';

import Image from 'components/ImageV2';
import Paragraph from 'components/Paragraph';
import { IMAGE_BG_COLOR } from 'constants/images';
import { largeUp } from 'constants/mediaQueries';
import Theme from 'styles/theme';

const IMAGE_SIZE = 650;

const PdpRecommendationsCard = ({
  analyticsProperties,
  imageLink,
  productName,
  linkUrl,
  showColorway,
  colorway,
  slotId,
  onClick,
}) => (
  <a
    className="PdpRecommendationsCard"
    href={linkUrl}
    onClick={e => {
      // siema prevents default when dragging link, but onClick still fires
      if (e.defaultPrevented === false) {
        onClick({
          slotId,
          productName,
          analyticsProperties,
        });
      }
    }}
  >
    <div className="PdpRecommendationsCard__image-wrapper">
      <Image
        src={imageLink}
        alt={productName}
        className="PdpRecommendationsCard__image"
        width={IMAGE_SIZE}
        height={IMAGE_SIZE}
      />
    </div>
    <div className="PdpRecommendationsCard__product-name">
      <Paragraph className="ProductName">
        <b>{productName}</b>
      </Paragraph>
      {showColorway && <Paragraph className="Colorway">{colorway}</Paragraph>}
    </div>
    <style jsx>{`
      .PdpRecommendationsCard {
        cursor: pointer;
        text-decoration: none;
        box-shadow: 0 4px 14px 0 rgba(0, 0, 0, 0.12);
        display: block;
        width: 100%;
      }

      .PdpRecommendationsCard__image-wrapper {
        width: 100%;
        background-color: ${IMAGE_BG_COLOR};
        position: relative;
        overflow: hidden;
      }

      .PdpRecommendationsCard__product-name {
        padding: ${Theme.get('spacing') * 3}px;
      }

      .PdpRecommendationsCard__product-name p.Paragraph.ProductName {
        letter-spacing 0.5px;
        font-size: ${Theme.get('font-size-description-px')};
        line-height: 20px;
      }
      @media ${largeUp} {
        .PdpRecommendationsCard__product-name p.Paragraph.ProductName {
          font-size: ${Theme.get('font-size-px')};
          line-height: 24px;
        }
      }
    `}</style>
    <style jsx global>{`
      .PdpRecommendationsCard > * {
        pointer-events: none; // required to make anchor tags work with siema
      }

      .PdpRecommendationsCard__image {
        display: block;
        width: 100%;
        height: auto;
      }

      .PdpRecommendationsCard__product-name p.Paragraph {
        font-size: 14px;
      }

      .PdpRecommendationsCard__product-name p.Paragraph.ProductName {
        margin: 0 0 ${Theme.get('spacing')}px;
      }

      .PdpRecommendationsCard__product-name p.Paragraph.Colorway {
        margin: 0;
      }

      .PdpRecommendationsCard__image {
        transition: transform ${Theme.get('transition-duration-ms')}
          ${Theme.get('transition-timing-ease-out')};
      }
      @media (hover: hover) {
        .PdpRecommendationsCard:hover .PdpRecommendationsCard__image {
          transform: scale(1.05);
        }
      }
    `}</style>
  </a>
);

PdpRecommendationsCard.propTypes = {
  analyticsProperties: PropTypes.shape({}).isRequired,
  imageLink: PropTypes.string.isRequired,
  productName: PropTypes.string.isRequired,
  linkUrl: PropTypes.string.isRequired,
  showColorway: PropTypes.bool,
  colorway: PropTypes.string,
  slotId: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

PdpRecommendationsCard.defaultProps = {
  showColorway: false,
  colorway: '',
  onClick: () => {},
};

export default PdpRecommendationsCard;
